module.exports = __webpack_public_path__ + "files/d50e1d11c10d978c94233303a4678e99.png";